export const PortraitOrientation = () => (
  <style type="text/css">
    {`
      @media print {
        @page {
          size: portrait;
        }
      }
    `}
  </style>
);
